function UsernameStep(data) {
    var self = this;
    BaseStepModel.apply(self, ['username_panel']);

    self.usernameLabel = data.UsernameLabelText;
    self.usernameDescription = data.UsernameDescription;
    self.usernameMinLength = data.UsernameMinLength;
    self.usernameMaxLength = data.UsernameMaxLength;

    self.username = ko.observable(null);
    self.isSubmittingUsername = ko.observable(false);
    self.isButtonDisabled = ko.computed(function () {
        return self.isSubmittingUsername() || !self.username() || !$('#username_form').valid();
    });
    self.hasReachedMaximumUsernameTries = ko.observable(false);

    // Handle case when username label is "Username" and we want the placeholder to be "Enter a username"
    // and the case when username label is "User ID" and we want the placeholder to be "Enter a user ID"
    var isUsernameLabelLowerOrMixedCase = self.usernameLabel.charAt(1) === self.usernameLabel.charAt(1).toLowerCase(); // Is second letter lowercase?
    var usernameLabelWithFirstCharacterLowered = self.usernameLabel.charAt(0).toLowerCase() + self.usernameLabel.slice(1);
    self.usernameText = isUsernameLabelLowerOrMixedCase ? usernameLabelWithFirstCharacterLowered : self.usernameLabel;
    self.usernamePlaceholderText = Alkami.Localization.SiteText['Registration.Mobile.UsernamePlaceHolderPrefix'] + self.usernameText;

    self.chooseUsername = function () {
        if (!$('#username_form').valid())
            return;

        self.validationErrors([]);
        self.isSubmittingUsername(true);

        if (self.hasReachedMaximumUsernameTries()) {
            self.submitForm();
            return;
        }

        $.ajax('/MobileRegistration/CheckUsernameAvailability', {
            data: $('#username_form').serialize(),
            type: 'POST',
            cache: false,
            success: function (available, status) {
                self.isSubmittingUsername(false);

                var hasUsernames = available.userNames != null && available.userNames.length > 0;
                self.hasReachedMaximumUsernameTries(available.retriesLeft === 0);

                if (hasUsernames && self.hasReachedMaximumUsernameTries()) {
                    self.username(available.userNames[0]);
                    self.validationErrors([Alkami.Localization.SiteText['Registration.ErrorMessage.ReachedMaximumNumberOfAttempts'] + Alkami.Localization.SiteText['Registration.ErrorMessage.ChosenUsernameForYou.First'] + self.usernameText + Alkami.Localization.SiteText['Registration.ErrorMessage.ChosenUsernameForYou.Second'] + self.usernameText + Alkami.Localization.SiteText['Registration.ErrorMessage.ChosenUsernameForYou.Third']]);
                    return;
                } else if (self.hasReachedMaximumUsernameTries()) {
                    self.validationErrors([Alkami.Localization.SiteText['Registration.ErrorMessage.ReachedMaximumNumberOfAttempts']]);
                    return;
                }

                if (hasUsernames && available.userNames[0] === self.username()) { // username is available
                    self.submitForm();
                }
                else {
                    self.validationErrors([self.usernameLabel + available.message]);
                }

                var $panel = $('#username_panel');
                if (self.validationErrors().length === 0) {
                    $panel.find('.ani-input-error-block').height(0);
                    $panel.find('.input-container').removeClass('ani-input-error');
                } else {
                    $panel.find('.ani-input-error-block').height($panel.find('.error-text').outerHeight(true));
                    $panel.find('.input-container').addClass('ani-input-error');
                }
            },
            error: function () {
                self.isSubmittingUsername(false);
                self.validationErrors([Alkami.Localization.SiteText['ShortGeneralErrorMessage']]);
            }
        });
    };

    self.submitForm = function () {
        self.validationErrors([]);
        self.isSubmittingUsername(true);

        $.ajax({
            url: $('#username_form').attr('action'),
            type: 'POST',
            data: $('#username_form').serialize(),
            success: function (result) {
                self.isSubmittingUsername(false);

                if (result.isValid) {
                    self.isDone(true);
                } else {
                    self.validationErrors(result.error_messages);
                }
            },
            error: function () {
                self.isSubmittingUsername(false);
                self.validationErrors([Alkami.Localization.SiteText['ShortGeneralErrorMessage']]);
            }
        });
    };

    self.show = function () {
        self.resetState();
        self.isSubmittingUsername(false);
        self.hasReachedMaximumUsernameTries(false);
        registrationArea.showUsernamePanel(self.usernameLabel);
    }
}